<template>
  <section>
    <RadioWithInputAndValidation
      v-model="internalProjet.milieuGenerique"
      :label="$t('instruction.milieu-generique')"
      :data="allMilieuxGenerique"
      :option-labels="allMilieuxGeneriqueLabels()"
      :vertical-display="true"
      vid="milieuxGenerique"
      :disabled="readOnly"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import RadioWithInputAndValidation from "@/views/inputs/RadioWithInputAndValidation.vue"
import { EnumHelper } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "InstructionMilieuxGeneriques",
  components: {
    RadioWithInputAndValidation,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["projet-annuel-updated"],
  data() {
    return {
      internalProjet: { ...this.projetAnnuel },
      allMilieuxGenerique: EnumHelper.allMilieuxGenerique,
      isInitializing: true,
    }
  },
  mounted(): void {
    this.$nextTick(() => {
      this.isInitializing = false
    })
  },
  watch: {
    projetAnnuel(): void {
      const previousMilieuGenerique = this.internalProjet.milieuGenerique
      this.internalProjet = { ...this.projetAnnuel }
      // Restore to prevent false positive emit if value didn't actually change
      if (previousMilieuGenerique === this.internalProjet.milieuGenerique) {
        return
      }
    },
    "internalProjet.milieuGenerique"(): void {
      if (!this.isInitializing) {
        this.$emit("projet-annuel-updated", this.internalProjet)
      }
    },
  },
  methods: {
    allMilieuxGeneriqueLabels(): string[] {
      return this.allMilieuxGenerique.map((milieuGenerique) => {
        return this.$t("instruction." + milieuGenerique).toString()
      })
    },
  },
})
</script>
